import styled from 'styled-components';
import { createShouldForwardProp } from '../../helpers/createShouldForwardProp';
import { background, compose, createPropTypes, flexbox, layout, space } from '../../styles/system';
const styleProps = compose(background, flexbox, layout, space).withDefaults({
  display: 'flex'
});
const shouldForwardProp = createShouldForwardProp(styleProps.propNames);
const Box = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp
})(styleProps);
Box.displayName = 'Box';
Box.propTypes = createPropTypes(styleProps.propNames);
export { Box };